import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin-routing.module';
import { ShareModule } from '../share.module';
//
import { AdminComponent } from './admin.component';
import { HeaderComponent } from './header/header.component';
import { LeftMenuComponent } from './leftmenu/leftmenu.component';
//
import { DashBoardComponent } from './dashboard/dashboard.component';
import { BannerComponent } from './banner/banner.component';
import { MenuMangeComponent } from './menumange/menumange.component';
import { AdminService } from './admin.service';
import { ProfileComponent } from './profile/profile.component';
import { AdminShareModule } from './adminshare.module';
import { FooterComponent } from './footer/footer.component';
import { InfoPublicComponent } from './infopublic/infopublic.component';
import { LinkAliasComponent } from './linkalias/linkalias.component';
import { MetatagComponent } from './metatag/metatag.component';
import { OrderComponent } from './order/order.component';

@NgModule({
  declarations: [
    AdminComponent,
    HeaderComponent,
    FooterComponent,
    LeftMenuComponent,
    DashBoardComponent,
    ProfileComponent,
    MenuMangeComponent,
    BannerComponent,
    InfoPublicComponent,
    LinkAliasComponent,
    MetatagComponent,
    OrderComponent
  ],
  imports: [
    AdminRoutingModule,
    AdminShareModule,
    ShareModule
  ],
  providers: [AdminService],
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts